import React, { useEffect } from 'react';
import styled from 'styled-components';
import belowIcon from '../../../asset/icon/below.png';
import UniversalIconBtn from '../../../shared/component/headless/button/UniversalIconBtn';
import { getSettingsMessage } from '../../../shared/constants/pageMessages';
import { useModalStore } from '../../../shared/store/portal/modalStore';
import ApprovalRequestSection from '../ApprovalRequestSection';

const ApprovalRequestModalMobile: React.FC = () => {
  const { clearModal } = useModalStore();
  const handleClose = () => clearModal(400);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') clearModal(400);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [clearModal]);

  return (
    <MobileBody>
      <TitleWrapper>
        <Title>{getSettingsMessage('SETTINGS_APPROVAL_REQUESTS')}</Title>
        <UniversalIconBtn
          size="fit"
          border={false}
          isTransparent
          backgroundImg={belowIcon}
          onClick={handleClose}
          aria-label="Close"
        />
      </TitleWrapper>
      <ApprovalRequestSection isMobile />
    </MobileBody>
  );
};

const MobileBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
  max-height: calc(100dvh - 40px);
  padding-bottom: 20px;
  overflow: hidden;
`;

const TitleWrapper = styled.div`
  position: relative;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: ${({ theme }) => theme.colors.color_Gray_02};
  margin-top: clamp(12px, 2vh, 30px);
  margin-bottom: clamp(20px, 8vh, 30px);
`;

const Title = styled.h2`
  color: ${({ theme }) => theme.colors.color_Gray_02};
  ${({ theme }) => theme.typography.Body_01_1};
`;

export default ApprovalRequestModalMobile;
